import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import * as XLSX from "xlsx";

import { fetchMachines, addMachine, resetMachines } from "../actions/machines";
import MachineList from "../components/MachineList";
import ErrorMessage from "../components/ErrorMessage";
import { fetchBateriesCSV } from "../actions/matrixs";
import { fetchSNCSV } from "../actions/matrixs";

import "../styles/MachinesAdminView.css";

// VACWAY TECH internal customer (machines in stock / production)
const VACWAY_CUSTOMER_ID = "620d1664db950220fabc0a41";

class MachinesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddModal: false,
      isSubmitting: false,
      fakeProgress: 0,
      hideVacway: false,
    };

    this.handleDownloadBateriesCSV = this.handleDownloadBateriesCSV.bind(this);
    this.handleDownloadSNCSV = this.handleDownloadSNCSV.bind(this);
    this.handleDownloadOfflineCSV = this.handleDownloadOfflineCSV.bind(this);
  }

  handleDownloadBateriesCSV() {
    const { fetchBateriesCSV } = this.props;

    fetchBateriesCSV();
  }

  handleDownloadSNCSV() {
    const { fetchSNCSV } = this.props;

    fetchSNCSV();
  }

  handleDownloadOfflineCSV() {
    const { machines } = this.props;
    if (!machines || machines.length === 0) return;

    const now = Date.now();

    // VACWAY TECH machines are always excluded from the export
    const offlineMachines = machines.filter((machine) => {
      const customerId =
        machine.Customer && machine.Customer._id
          ? machine.Customer._id
          : machine.Customer;
      if (customerId === VACWAY_CUSTOMER_ID) return false;
      const lastSignalTime = machine.Last_signal
        ? Date.parse(machine.Last_signal)
        : 0;
      return (now - lastSignalTime) / 1000 >= 60 * 5;
    });

    if (offlineMachines.length === 0) {
      alert("No hay máquinas offline.");
      return;
    }

    const sorted = [...offlineMachines].sort((a, b) => {
      const customerA = a.Customer && a.Customer.Fullname ? a.Customer.Fullname : "";
      const customerB = b.Customer && b.Customer.Fullname ? b.Customer.Fullname : "";
      return (
        customerA.localeCompare(customerB) ||
        (a.Serial || "").localeCompare(b.Serial || "")
      );
    });

    const data = sorted.map((machine) => ({
      Cliente:
        machine.Customer && machine.Customer.Fullname
          ? machine.Customer.Fullname
          : "",
      Serial: machine.Serial || "",
      "Última señal": machine.Last_signal
        ? new Date(machine.Last_signal).toLocaleString()
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet["!cols"] = [{ wch: 35 }, { wch: 15 }, { wch: 22 }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Offline");
    XLSX.writeFile(
      workbook,
      `maquinas_offline_${new Date().toISOString().substring(0, 10)}.xlsx`
    );
  }

  componentDidMount() {
    const { fetchMachines, resetMachines, role, type } = this.props;
    resetMachines();
    if (role === "ADMIN" && type === "PRODUCCION") {
      fetchMachines("620d1664db950220fabc0a41");
    } else {
      fetchMachines();
    }
    this.startFakeProgress();
  }

  componentDidUpdate(prevProps) {
    // Detect transition from empty to loaded machines
    if (!prevProps.machines?.length && this.props.machines?.length) {
      this.finishFakeProgress();
    }
  }

  startFakeProgress() {
    this.setState({ fakeProgress: 0 });

    if (this.fakeProgressInterval) {
      clearInterval(this.fakeProgressInterval);
    }

    // Increase progress gradually up to 80% over ~5s
    this.fakeProgressInterval = setInterval(() => {
      this.setState((prev) => {
        if (prev.fakeProgress >= 80) {
          clearInterval(this.fakeProgressInterval);
          return prev;
        }
        return { fakeProgress: prev.fakeProgress + 1 };
      });
    }, 31); // ~80 steps * 62ms = 4960ms ≈ 5s
  }

  finishFakeProgress() {
    if (this.fakeProgressInterval) clearInterval(this.fakeProgressInterval);

    this.setState({ fakeProgress: 100 });

    // Optional: fade-out or reset after a second
    setTimeout(() => this.setState({ fakeProgress: 0 }), 1000);
  }

  componentWillUnmount() {
    if (this.fakeProgressInterval) {
      clearInterval(this.fakeProgressInterval);
    }
  }

  openAddModal = () => this.setState({ showAddModal: true });
  closeAddModal = () => this.setState({ showAddModal: false });

  handleAddMachine = async () => {
    const { addMachine, fullname, fetchMachines, role, type } = this.props;

    this.setState({ isSubmitting: true });

    try {
      const response = await addMachine({ Executor: fullname });
      if (response && !response.error) {
        this.setState({ showAddModal: false });
        if (role === "ADMIN" && type === "PRODUCCION") {
          fetchMachines("620d1664db950220fabc0a41");
        } else {
          fetchMachines();
        }
      } else {
        alert("Error al añadir la máquina.");
      }
    } catch (error) {
      console.error(error);
      alert("Error al añadir la máquina.");
    }

    this.setState({ isSubmitting: false });
  };

  render() {
    const { machines, error, role, type, loading } = this.props;

    if (loading || !machines) {
      const progress = this.state.fakeProgress;
      return (
        <div className="kpi-loading min-vh-100 d-flex flex-column align-items-center justify-content-center">
          <img
            className="kpi-loading-logo"
            src="/images/logo_blue.png"
            alt="Logo"
            height={56}
          />
          <div
            className="kpi-progress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={progress}
          >
            <div
              className="kpi-progress-fill"
              style={{
                width: `${progress}%`,
                transition: "width 0.3s ease-out",
              }}
            />
          </div>
          <div className="kpi-progress-text">{progress}%</div>
        </div>
      );
    }

    if (error) return <ErrorMessage message={error.message} />;

    const { hideVacway } = this.state;

    // Hide machines assigned to the internal VACWAY TECH customer when toggled
    const visibleMachines = hideVacway
      ? machines.filter((machine) => {
          const customerId =
            machine.Customer && machine.Customer._id
              ? machine.Customer._id
              : machine.Customer;
          return customerId !== VACWAY_CUSTOMER_ID;
        })
      : machines;

    // Online/offline derived like MachineList: no signal in the last 5 minutes = OFFLINE
    const now = Date.now();
    const offlineCount = visibleMachines.filter((machine) => {
      const lastSignalTime = machine.Last_signal
        ? Date.parse(machine.Last_signal)
        : 0;
      return (now - lastSignalTime) / 1000 >= 60 * 5;
    }).length;
    const onlineCount = visibleMachines.length - offlineCount;

    return (
      <div className="machines-admin-view">
        {/* Header */}
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-desktop mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Kioscos</span>
              </h1>
              <div className="mach-admin-badges">
                <span className="mach-badge total">
                  <i className="fas fa-desktop"></i>
                  {visibleMachines.length} máquinas
                </span>
                <span className="mach-badge online">
                  <i className="fas fa-wifi"></i>
                  {onlineCount} online
                </span>
                <span className="mach-badge offline">
                  <i className="fas fa-exclamation-triangle"></i>
                  {offlineCount} offline
                </span>
              </div>
            </div>
            <div className="header-actions">
              {role === "ADMIN" &&
                (type === "MASTER" || type === "PRODUCCION") && (
                  <>
                    <button
                      type="button"
                      className={`mach-admin-btn ${hideVacway ? "primary" : "secondary"}`}
                      onClick={() => this.setState({ hideVacway: !hideVacway })}
                      title="Ocultar/mostrar máquinas asignadas a VACWAY TECH"
                    >
                      <i
                        className={`fas ${hideVacway ? "fa-eye" : "fa-eye-slash"}`}
                      ></i>
                      <span>
                        {hideVacway ? "Mostrar Vacway" : "Ocultar Vacway"}
                      </span>
                    </button>
                    <button
                      className="mach-admin-btn success"
                      onClick={this.handleDownloadBateriesCSV}
                    >
                      <i className="fas fa-file-excel"></i>
                      <span>Baterías</span>
                    </button>
                    <button
                      className="mach-admin-btn warning"
                      onClick={this.handleDownloadSNCSV}
                    >
                      <i className="fas fa-file-excel"></i>
                      <span>Serials</span>
                    </button>
                    <button
                      className="mach-admin-btn danger"
                      onClick={this.handleDownloadOfflineCSV}
                      title="Descargar CSV de máquinas offline"
                    >
                      <i className="fas fa-file-excel"></i>
                      <span>Offline</span>
                    </button>
                    <button
                      type="button"
                      className="mach-admin-btn primary"
                      onClick={this.openAddModal}
                    >
                      <i className="fas fa-plus"></i>
                      <span>Nueva</span>
                    </button>
                  </>
                )}
            </div>
          </div>
        </div>
        <MachineList machines={visibleMachines} />

        <Modal
          isOpen={this.state.showAddModal}
          toggle={this.closeAddModal}
          centered
        >
          <ModalHeader toggle={this.closeAddModal}>
            Nueva Máquina - Confirmación
          </ModalHeader>
          <ModalBody>
            Vas a añadir una máquina nueva con parámetros predefinidos.
            <br />
            <br />
            También se añadirá un contrato nuevo para esta máquina a nombre de{" "}
            <strong>VACWAY TECH</strong>.<br />
            <br />
            Más tarde puedes editar esos documentos para modificar sus
            parámetros.
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.closeAddModal}>
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={this.handleAddMachine}
              disabled={this.state.isSubmitting}
            >
              {this.state.isSubmitting ? "Añadiendo..." : "Añadir"}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  machines: state.machines.machines,
  loading: state.machines.loading,
  error: state.machines.error,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  resetMachines: bindActionCreators(resetMachines, dispatch),
  fetchBateriesCSV: bindActionCreators(fetchBateriesCSV, dispatch),
  fetchSNCSV: bindActionCreators(fetchSNCSV, dispatch),
  addMachine: bindActionCreators(addMachine, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachinesView);
